/**
 * Transforme un texte brut en HTML formaté et sécurisé
 * - Normalise CRLF -> LF et trim fin de lignes
 * - Borne les sauts de ligne au début/fin (maxEdgeBreaks)
 * - Auto-link URLs (http/https + www.) et emails
 * - 1 saut \n -> <br>, 2 sauts \n\n -> nouveau <p> (on conserve les espacements internes)
 * - Sanitize (whitelist de balises/attributs)
 */
export function formatText(text, maxEdgeBreaks = 3) {
  if (!text || !text.trim()) return "";

  // 1) Normalisation de base (⚠️ on NE réduit pas les \n multiples internes)
  let t = String(text);
  t = t.replace(/\r\n?/g, "\n");   // CRLF/CR -> LF
  t = t.replace(/[ \t]+$/gm, "");  // trim fin de lignes

  // 1bis) Borne des sauts de ligne en TÊTE et en FIN
  // début : > maxEdgeBreaks -> maxEdgeBreaks
  const headRe = new RegExp(`^\\n{${maxEdgeBreaks + 1},}`);
  t = t.replace(headRe, "\n".repeat(maxEdgeBreaks));
  // fin : > maxEdgeBreaks -> maxEdgeBreaks
  const tailRe = new RegExp(`\\n{${maxEdgeBreaks + 1},}$`);
  t = t.replace(tailRe, "\n".repeat(maxEdgeBreaks));

  // 2) Auto-link (emails, www., http/https)
  // emails
  t = t.replace(/\b[A-Z0-9._%+\-]+@[A-Z0-9.\-]+\.[A-Z]{2,}\b/gi, (e) => {
    return `<a href="mailto:${e}">${e}</a>`;
  });
  // www. -> lien https
  t = t.replace(/(^|\s)(www\.[^\s<]+)/gi, (_, space, url) => {
    return `${space}<a href="https://${url}" target="_blank" rel="noopener">${url}</a>`;
  });
  // http / https
  t = t.replace(/(https?:\/\/[^\s<]+)/gi, (u) => {
    return `<a href="${u}" target="_blank" rel="noopener">${u}</a>`;
  });

  // 3) Paragraphes : on coupe sur EXACTEMENT deux sauts \n\n
  const html = t
    .split(/\n\n/)
    .map(p => {
      let inner = p.replace(/\n/g, "<br>"); // \n simple -> <br>
      if (inner === "") inner = "&nbsp;";   // paragraphe vide -> espace insécable
      return `<p>${inner}</p>`;
    })
    .join("");

  // 4) Sanitize (whitelist)
  const allowedTags  = ["A","P","BR","STRONG","EM","B","I","UL","OL","LI","CODE","PRE"];
  const allowedAttrs = ["href","target","rel"];

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  (function sanitize(node) {
    [...node.children].forEach(child => {
      const tag = child.tagName;
      if (!allowedTags.includes(tag)) {
        child.replaceWith(...child.childNodes);
      } else {
        [...child.attributes].forEach(attr => {
          if (!allowedAttrs.includes(attr.name.toLowerCase())) {
            child.removeAttribute(attr.name);
          }
        });
        if (tag === "A") {
          const href = child.getAttribute("href") || "";
          if (!/^(https?:\/\/|mailto:)/i.test(href)) child.removeAttribute("href");
          child.setAttribute("target", "_blank");
          child.setAttribute("rel", "noopener");
        }
        sanitize(child);
      }
    });
  })(doc.body);

  return doc.body.innerHTML;
}
